export * from './lib/index';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
